import axios from "axios";
import { AuthService } from "./AuthService";

export const USER_API =
  process.env.REACT_APP_API_ENDPOINT + process.env.REACT_APP_USER_SERVICE_PORT;

const AUTH_EXCLUDED_PATHS = [
  "auth/login",
  "auth/forgot-password/otp",
  "auth/forgot-password/reset",
];

const apiBase = process.env.REACT_APP_API_ENDPOINT || "";

const resolveRequestUrl = (config) => {
  const raw = config?.url || "";
  if (/^https?:\/\//i.test(raw)) return raw;
  const base = config?.baseURL || "";
  if (!base) return raw;
  return `${base.replace(/\/$/, "")}/${raw.replace(/^\//, "")}`;
};

export const shouldSkipJwtAuth = (config) => {
  if (config?.skipAuth) return true;
  if (config?.auth) return true;

  const url = resolveRequestUrl(config);

  if (/^https?:\/\//i.test(url) && apiBase && !url.includes(apiBase)) {
    return true;
  }

  return AUTH_EXCLUDED_PATHS.some((path) => url.includes(path));
};

export const getApiHeaderOpen = () => ({
  headers: {
    "Content-Type": "application/json",
  },
});

export const getApiHeader = () => {
  const acceptRole = AuthService.getAcceptRole();
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + AuthService.currentUser()?.token,
      ...(acceptRole ? { "Accept-Role": acceptRole } : {}),
    },
  };
};

axios.interceptors.request.use((config) => {
  if (shouldSkipJwtAuth(config)) {
    return config;
  }

  const token = AuthService.currentUser()?.token;
  if (!token) {
    return config;
  }

  config.headers = config.headers || {};

  if (!config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  const acceptRole = AuthService.getAcceptRole();
  if (acceptRole && !config.headers["Accept-Role"]) {
    config.headers["Accept-Role"] = acceptRole;
  }

  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      const config = error?.config;
      if (
        config &&
        !shouldSkipJwtAuth(config) &&
        AuthService.isUserLoggedIn()
      ) {
        AuthService.logout();
      }
    }
    return Promise.reject(error);
  }
);
